import { usePlausible as usePlausibleOriginal } from "next-plausible";

export function usePlausible() {
  const plausible = usePlausibleOriginal();

  return plausible;
}
